import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import arrowBack from "../../../assets/images/arrow-back.png";
import AppointmentRequest from "./AppointmentRequest";
import Notification from "./Notification";
import axiosInstance from "../../../axios/axios";
import { ModalDialog, DataDiv, Text, RowHead, Image } from "./styles";
import { Data } from "./chats/Style";
import { Row } from "./Message/styles";
import { globalColor, globalFont } from "../../utils/RepeatFunctions/Schedule";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { useHistory } from "react-router-dom";

let storedNames = localStorage.getItem("setroles");

const { TabPane } = Tabs;
const Notifications = (props) => {
  const history = useHistory();
  const [ModalAnimat] = useState(true);
  const [DataCount, setDataCount] = useState(props.appData);
  const [MsgCount, setMsgCount] = useState(0);
  const [count, setCount] = useState("0");
  const [actTab, setActTab] = useState("1");
  const [treatmentPlans, setTreatmentPlans] = useState([]);

  const [generalNotificationModal, setGeneralNotificationModal] = useState(
    props.genNotification
  );

  const success = (val) => {
    setDataCount(val);
  };
  const handleactive = (activeKey) => {
    setActTab(activeKey);
    if (activeKey === "2") {
      axiosInstance
        .get("/vozo/patient/notification/data?type=remove&id=0")
        .then(() => {
          props.getNotify();
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
  };

  const handleReviewPlan = async (planID, patID, plan) => {
    let payload = {
      isReviewed: 1,
      planId: planID,
      patientId: patID,
    };
    let encrypted = Encrypt_Value(payload, "vozo");

    try {
      await axiosInstance.put("/vozo/patient/updatetreatmentPlan", encrypted);
      history.push(`/patient/treatmentplan/${patID}`, {
        planState: { planRow: plan, planForm: true },
        refreshKey: Date.now(),
      });
      props.changeDrop();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setCount(props.notifyCount);
    setMsgCount(props.MsgCount);

    if (props.show === false) {
      setActTab("1");
      setGeneralNotificationModal(props.genNotification);
    }
  }, [props.MsgCount, props.show, props.count, props.genNotification]);

  const today = new Date();

  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const year = today.getFullYear();
  const formattedDate = `${month}-${day}-${year}`;

  return (
    <ModalDialog animation={ModalAnimat} isGeneral={generalNotificationModal}>
      {generalNotificationModal ? (
        <>
          <Row borderBottom="1px solid #cbd5e0" padding="12px 16px 12px 16px">
            <RowHead color="#2C7BE5">
              <span style={{ marginRight: "8px" }}>
                <Image
                  src={arrowBack}
                  height="24px"
                  width="24px"
                  alt="back"
                  cursor="pointer"
                  onClick={() => setGeneralNotificationModal(false)}
                ></Image>
              </span>
              <span style={{ color: "#2C7BE5" }}>General Notification</span>
            </RowHead>
          </Row>
          <Row
            boxShadow="5px 5px 8px rgba(20, 46, 110, 0.15)"
            radius="8px"
            border=" 1px solid #cbd5e0"
            margin="8px 8px 22px 8px "
          >
            <Data height="336px" width="100%">
              {treatmentPlans.length == 0 || treatmentPlans.lenght < 0 ? (
                <>
                  <DataDiv mt="5px">
                    <Text
                      display="flex"
                      fontFamily={globalFont}
                      fontWeight="500"
                      fontSize="14px"
                      color="rgba(46, 46, 46, 0.75)"
                      lineHeight="20px"
                      justifyContent="center"
                    >
                      No New Notification{" "}
                    </Text>
                  </DataDiv>
                </>
              ) : (
                <>
                  {treatmentPlans.map((row, ind) => (
                    <DataDiv
                      id={row.id}
                      padding="12px 12px 12px 16px"
                      bb="1px solid #cbd5e0"
                      cursor="pointer"
                      onClick={(e) => {
                        if (storedNames.show_noti_viewOnly) {
                          alert("You only have view-only access.");
                        } else {
                          handleReviewPlan(row.id, row.pat_id, row);
                        }
                      }}
                      key={ind}
                    >
                      <DataDiv display="flex">
                        {props.profileimage ? (
                          <>
                            <Image
                              src={props.profileimage}
                              borderRadius="40px"
                              height="24px"
                              width="24px"
                              mr="8px"
                            ></Image>
                          </>
                        ) : (
                          <DataDiv
                            textAlign="center"
                            br="40px"
                            height="24px"
                            width="24px"
                            mr="8px"
                            background="#A8AEBE"
                          >
                            <Text
                              fontFamily={globalFont}
                              fontWeight="500"
                              fontSize="14px"
                              color="#ffffff"
                              lineHeight="16px"
                              mt="4px !important"
                            >
                              {" "}
                              {row.pov_name.charAt(0)}
                            </Text>
                          </DataDiv>
                        )}
                        <Text
                          display="flex"
                          fontFamily={globalFont}
                          fontWeight="400"
                          fontSize="14px"
                          color="#rgba(46, 46, 46, 1)"
                          lineHeight="20px"
                          mr="20px"
                        >
                          {row.pov_name}
                        </Text>
                        <Text
                          display="flex"
                          fontFamily={globalFont}
                          fontWeight="500"
                          fontSize="15px"
                          color="rgba(46, 46, 46, 1)"
                          lineHeight="18px"
                          mr="5px"
                        >
                          {formattedDate}
                        </Text>
                      </DataDiv>
                      <DataDiv mt="5px">
                        <Text
                          display="flex"
                          fontFamily={globalFont}
                          fontWeight="500"
                          fontSize="14px"
                          color="rgba(46, 46, 46, 0.75)"
                          lineHeight="20px"
                        >
                          Patient treatment plan is awaiting your review
                        </Text>
                      </DataDiv>
                    </DataDiv>
                  ))}
                </>
              )}
            </Data>
          </Row>
        </>
      ) : (
        <>
          <DataDiv
            ml="188px"
            minWidth="16px"
            justifyContent="center"
            display="flex"
            aspectRatio="1/1"
            MaxWidth="24px"
            background={globalColor}
            br="50px"
            position="absolute"
            mt="8px"
          >
            <Text
              textAlign="center"
              fontFamily={globalFont}
              fontWeight="500"
              fontSize="12px"
              color="#ffffff"
              lineHeight="15px"
              height="100%"
              display="flex"
            >
              {DataCount.length}
            </Text>
          </DataDiv>
          <DataDiv
            ml="310px"
            minWidth="16px"
            justifyContent="center"
            alignItems="center"
            display="flex"
            aspectRatio="1/1"
            MaxWidth="24px"
            background={globalColor}
            br="50px"
            position="absolute"
            mt="8px"
          >
            <Text
              textAlign="center"
              fontFamily={globalFont}
              fontWeight="500"
              fontSize="12px"
              color="#ffffff"
              lineHeight="15px"
              height="100%"
              display="flex"
            >
              {MsgCount}
            </Text>
          </DataDiv>
          <Tabs
            className="sec-msgs-left"
            activeKey={actTab}
            onChange={(activeKey) => handleactive(activeKey)}
          >
            <TabPane tab="Appointment Requests" key="1" className="appt-da">
              <AppointmentRequest
                appData={props.appData}
                profileimage={props.profileimage}
                success={success}
                successreload={props.successreload}
                refid={props.refid}
                calRefHandle={props.calRefHandle}
                show={props.show}
              />
            </TabPane>

            <TabPane tab="Notifications" key="2" className="appt-dash-head">
              <Notification
                dropChange={props.changeDrop}
                count={count}
                setGeneralNotificationModal={setGeneralNotificationModal}
                setTreatmentPlans={setTreatmentPlans}
              />
            </TabPane>
          </Tabs>
        </>
      )}
    </ModalDialog>
  );
};

export default Notifications;
